import { OwcButton } from '@one/react';
import { useTranslation } from 'core/i18n';

export const RefreshButton: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <OwcButton
      variant="primary"
      onClick={() => globalThis.location.reload()}
      data-testid="refresh-button"
    >
      {t('components.refresh-button.label')}
    </OwcButton>
  );
};
